export default "__VITE_ASSET__BZBRC2yB__"